<template>
    <div>
        <p class="text-brand-200 text-center mb-4">
            <b class="text-title-sm">
                {{
                    useDevice().isDesktop
                        ? $t("dashboardComponents_uploader_title")
                        : $t("dashboardComponents_uploader_title_mobile")
                }}
            </b>
            <br />
        </p>
        <AppButton size="sm" class="mx-auto flex items-center bg-brand-500 text-gray-100 rounded-full !px-6">
            <Icon name="tabler:upload" size="24px" class="mr-2" />
            <p class="text-body-md font-medium">Upload</p>
        </AppButton>
    </div>
</template>

<script setup lang="ts">
const handleId = computed(() => {
    if (useRoute().fullPath.includes("virtual-staging")) return "virtualstaging";
    if (useRoute().fullPath.includes("image-enhancement")) return "imageenhancement";
    if (useRoute().fullPath.includes("day-to-dusk")) return "daytodusk";
    if (useRoute().fullPath.includes("item-removal")) return "itemremoval";
});
</script>

<style scoped></style>
